var _templateObject = _taggedTemplateLiteralLoose(['\n  0%, 80%, 100% {\n    transform: scale(0);\n  }\n\n  40% {\n    transform: scale(1.0);\n  }\n'], ['\n  0%, 80%, 100% {\n    transform: scale(0);\n  }\n\n  40% {\n    transform: scale(1.0);\n  }\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: ', ';\n  width: 70px;\n  text-align: center;\n  margin: 1.5rem 1rem;\n'], ['\n  display: ', ';\n  width: 70px;\n  text-align: center;\n  margin: 1.5rem 1rem;\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  width: 8px;\n  height: 8px;\n  background-color: ', ';\n\n  margin-right: 2px;\n  border-radius: 100%;\n  display: inline-block;\n  animation: ', ' 1.4s infinite ease-in-out both;\n  animation-delay: ', ';\n'], ['\n  width: 8px;\n  height: 8px;\n  background-color: ', ';\n\n  margin-right: 2px;\n  border-radius: 100%;\n  display: inline-block;\n  animation: ', ' 1.4s infinite ease-in-out both;\n  animation-delay: ', ';\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from 'react';
import styled, { keyframes } from 'styled-components';

var Loader = function Loader(_ref) {
  var loading = _ref.loading;
  return React.createElement(
    Wrapper,
    { loading: loading },
    React.createElement(Bounce, { delay: '-0.32s' }),
    React.createElement(Bounce, { delay: '-0.16s' }),
    React.createElement(Bounce, { delay: '0s' })
  );
};

var bounceAnimation = keyframes(_templateObject);

var Wrapper = styled.div(_templateObject2, function (props) {
  return props.loading ? 'block' : 'none';
});

var Bounce = styled.div(_templateObject3, function (props) {
  return props.theme.color;
}, bounceAnimation, function (props) {
  return props.delay;
});

export default Loader;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@hype/chatbot/es/components/message-list/loader.js
// module id = 887
// module chunks = 1